import React, { useEffect, useState } from "react";

import userService from "../../services/user.service";

import DatePicker from "react-datepicker";
import moment from "moment/moment";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import { Comment } from "react-loader-spinner";
import Button from "@mui/material/Button";
import BikeScooterIcon from "@mui/icons-material/BikeScooter";
import roomService from "../../services/RoomService";
import MapParentComponent from "../maps/mapParent.component";
import { primaryHeader } from "../../common/Style/Style";
import PrimaryHeader from "../../common/Header/PrimaryHeader";

import { StyledTableCell, StyledTableRow } from "../../common/Style/Style";
export default function ViewSchedule(props) {
  const [myLoader, setMyLoader] = useState(true);

  const [selectDate, setSelectDate] = useState(new Date());
  const [schedule, setSchedule] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSelectedRoom, setIsSelectedRoom] = useState(false);
  const [scheduleLoading, setscheduleLoading] = useState(true);
  const [showParent, setShowParent] = useState(true);
  const [selectedRoom, setSelectedRoom] = useState();

  useEffect(() => {
    setSelectDate(new Date());
    setMyLoader(false);

    const date = {
      selectedFromTime: new Date(),
    };
    userService
      .getSchedule(date)
      .then((res) => {
        setSchedule(res.data);
        setLoading(true);
        setMyLoader(true);
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const refreshIt1 = (date) => {
    setLoading(false);
    setMyLoader(false);
    setSelectDate(date);
    setscheduleLoading(false);

    const date1 = {
      selectedFromTime: date,
    };
    console.log(date1);
    userService
      .getSchedule(date1)
      .then((res) => {
        setSchedule(res.data);
        setscheduleLoading(true);
        setLoading(true);
        console.log(res.data);
        setMyLoader(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  function showDirection(name) {
    roomService.getRoomByName(name).then((res) => {
      setSelectedRoom(res.data);
      setIsSelectedRoom(true);
      setShowParent(false);
    });
  }

  return (
    <div>
      {isSelectedRoom && <MapParentComponent room={selectedRoom} />}
      {showParent && (
        <div>
          <PrimaryHeader header="SCHEDULE" />
          <DatePicker
            onChange={(date) => refreshIt1(date)}
            selected={selectDate}
            minDate={new Date()}
            dateFormat="MMMM d, yyyy"
          />
          {!myLoader ? (
            <Comment
              visible={true}
              height="80"
              width="80"
              ariaLabel="comment-loading"
              wrapperStyle={{}}
              wrapperClass="comment-wrapper"
              color="#FFB81C"
              backgroundColor="#154734"
            />
          ) : (
            <div>
              {schedule.length > 0 ? (
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead
                      style={{
                        backgroundColor: "#154734",
                        color: "#FFB81C",
                      }}
                    >
                      <StyledTableRow>
                        <StyledTableCell>Room Id</StyledTableCell>
                        <StyledTableCell align="left">Name</StyledTableCell>
                        <StyledTableCell align="left">
                          From Date
                        </StyledTableCell>
                        <StyledTableCell align="left">To Date</StyledTableCell>
                        <StyledTableCell align="left">
                          Direction
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {schedule.map((row) => (
                        <StyledTableRow
                          key={row.id}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <StyledTableCell component="th" scope="row">
                            {row.room.name}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {row.name}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {moment(row.fromDate).format("hh:mm A")}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {moment(row.toDate).format("hh:mm A")}
                          </StyledTableCell>
                          <StyledTableCell>
                            <Button
                              style={{
                                backgroundColor: "#154734",
                                color: "#FFB81C",
                              }}
                              startIcon={<BikeScooterIcon />}
                              variant="outlined"
                              aria-label="text button group"
                              onClick={() => showDirection(row.room.name)}
                            >
                              {" "}
                              DIRECTION
                            </Button>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <div>No schedule found</div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
